export const platformData = [
  {
    id: null,
    type: "SIRI",
    typeName: "Siri",
    claimStatus: "UNKNOWN",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:23:25.000+02:00",
    lastChecked: "2025-07-31T00:42:59.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 23,
        NOT_IN_SYNC: ["ATTRIBUTES"],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "COUNTRY",
          "PHONE",
          "WEBSITE",
          "PHOTOS",
          "FAX",
          "CELLPHONE",
          "OPENINGHOURS",
          "CATEGORIES",
          "PAYMENT_OPTIONS",
          "LATITUDE",
          "LONGITUDE",
          "SOCIAL_PROFILES",
          "SPECIAL_OPENINGHOURS",
          "SOCIAL_POST",
          "DESCRIPTION_SHORT",
          "KEYWORDS",
          "TRANSACTION_LINKS",
          "SUBLOCALITY",
        ],
      },
    },
  },
  {
    id: 108618061,
    type: "INFO_IS_INFO",
    typeName: "infoisinfo",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:22.000+02:00",
    lastChecked: "2025-07-25T09:51:02.000+02:00",
    listingUrl:
      "https://amsterdam.infoisinfo.nl/kaart/factory-girl-brunch-restaurant-/754671",
    listingId: "NL754671",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-25T00:00:00.000+02:00",
        pointsReached: 15,
        maxPoints: 23,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "WEBSITE",
          "EMAIL",
          "DESCRIPTION_LONG",
          "CATEGORIES",
          "PHOTOS",
          "ATTRIBUTION",
          "SOCIAL_PROFILES",
          "BRANDS",
          "SERVICES",
          "PROVINCE",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "ADDRESS_EXTRA",
        ],
      },
    },
  },
  {
    id: 108618059,
    type: "AUDI",
    typeName: "Audi",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618040,
    type: "CYLEX",
    typeName: "Cylex",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-03-06T07:38:47.000+01:00",
    lastChecked: "2025-07-31T00:43:24.000+02:00",
    listingUrl:
      "https://www.cylex.nl/bedrijf/factory-girl-brunch-restaurant-12978694.html",
    listingId: "NL12978694",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 26,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "EMAIL",
          "WEBSITE",
          "OPENINGHOURS",
          "PROVINCE",
          "SPECIAL_OPENINGHOURS",
          "ADDRESS_EXTRA",
          "ADDRESS_DISPLAY",
          "PHOTOS",
          "DESCRIPTION_LONG",
          "SOCIAL_PROFILES",
          "PAYMENT_OPTIONS",
          "VIDEOS",
          "SOCIAL_POST",
          "CATEGORIES",
          "FAX",
          "CELLPHONE",
          "LATITUDE",
          "LONGITUDE",
          "LANGUAGES",
          "SERVICES",
          "OPENINGHOURS_NOTES",
          "ATTRIBUTION",
        ],
      },
    },
  },
  {
    id: 108618043,
    type: "NEXT_DOOR",
    typeName: "Nextdoor",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:24.000+02:00",
    lastChecked: "2025-07-29T20:45:00.000+02:00",
    listingUrl:
      "https://nextdoor.nl/pages/factory-girl-amsterdam-noord-holland",
    listingId: "521a131c-1bbc-49b4-96dd-08fe8ab1e28d",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-29T00:00:00.000+02:00",
        pointsReached: 3,
        maxPoints: 23,
        NOT_IN_SYNC: [
          "STREET",
          "STREET_NO",
          "CITY",
          "PROVINCE",
          "ZIP",
          "ADDRESS_DISPLAY",
          "PHONE",
          "PHOTOS",
          "CATEGORIES",
          "OPENINGHOURS",
          "DESCRIPTION_LONG",
          "LATITUDE",
          "LONGITUDE",
          "ATTRIBUTES",
        ],
        IN_SYNC: ["NAME", "COUNTRY", "CELLPHONE", "EMAIL", "WEBSITE"],
      },
    },
  },
  {
    id: 108618056,
    type: "FORD",
    typeName: "Ford",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618066,
    type: "BING",
    typeName: "Bing",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-03-20T00:06:01.000+01:00",
    lastChecked: "2025-07-31T00:43:11.000+02:00",
    listingUrl:
      "http://www.bing.com/maps?ss=ypid.YN8000x17448183444612200808&amp;amp;mkt=nl-NL",
    listingId: "YN8000x17448183444612200808",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 23,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "WEBSITE",
          "WEBSITE_EXTRA",
          "CATEGORIES",
          "PHOTOS",
          "OPENINGHOURS",
          "SPECIAL_OPENINGHOURS",
          "EMAIL",
          "SOCIAL_PROFILES",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "ADDRESS_EXTRA",
          "NPI",
          "ATTRIBUTES",
          "DESCRIPTION_LONG",
          "TRANSACTION_LINKS",
          "SUBLOCALITY",
        ],
      },
    },
  },
  {
    id: 108618047,
    type: "FOURSQUARE",
    typeName: "Foursquare",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:23.000+02:00",
    lastChecked: "2025-07-28T18:45:43.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-28T00:00:00.000+02:00",
        pointsReached: 3,
        maxPoints: 21,
        NOT_IN_SYNC: [
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "PHONE",
          "LATITUDE",
          "LONGITUDE",
          "OPENINGHOURS",
          "CATEGORIES",
        ],
        IN_SYNC: ["NAME", "COUNTRY", "FAX", "EMAIL", "WEBSITE"],
      },
    },
  },
  {
    id: 108618052,
    type: "MERCEDES",
    typeName: "Mercedes",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618046,
    type: "TOYOTA",
    typeName: "Toyota",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618049,
    type: "BAIDU",
    typeName: "BAIDU",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2023-08-26T23:49:24.000+02:00",
    lastChecked: "2023-09-27T15:07:54.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618041,
    type: "TOMTOM",
    typeName: "TomTom",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:21.000+02:00",
    lastChecked: "2025-07-06T08:39:46.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-06T00:00:00.000+02:00",
        pointsReached: 3,
        maxPoints: 21,
        NOT_IN_SYNC: [
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "PHONE",
          "OPENINGHOURS",
          "PAYMENT_OPTIONS",
          "CATEGORIES",
          "LATITUDE",
          "LONGITUDE",
        ],
        IN_SYNC: ["NAME", "COUNTRY", "FAX", "WEBSITE", "EMAIL"],
      },
    },
  },
  {
    id: null,
    type: "FIND_OPEN",
    typeName: "Find Open",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-03-06T07:38:47.000+01:00",
    lastChecked: "2025-07-31T00:43:24.000+02:00",
    listingUrl:
      "https://vind-open.nl/amsterdam/factory-girl-brunch-restaurant-376865",
    listingId: "NL12978694",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 26,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "EMAIL",
          "WEBSITE",
          "OPENINGHOURS",
          "PROVINCE",
          "SPECIAL_OPENINGHOURS",
          "ADDRESS_EXTRA",
          "ADDRESS_DISPLAY",
          "PHOTOS",
          "DESCRIPTION_LONG",
          "SOCIAL_PROFILES",
          "PAYMENT_OPTIONS",
          "VIDEOS",
          "SOCIAL_POST",
          "CATEGORIES",
          "FAX",
          "CELLPHONE",
          "LATITUDE",
          "LONGITUDE",
          "LANGUAGES",
          "SERVICES",
          "OPENINGHOURS_NOTES",
          "ATTRIBUTION",
        ],
      },
    },
  },
  {
    id: 108618042,
    type: "FIAT",
    typeName: "Fiat",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618058,
    type: "APPLE_MAPS",
    typeName: "Apple Maps",
    claimStatus: "UNKNOWN",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:23:25.000+02:00",
    lastChecked: "2025-07-31T00:42:59.000+02:00",
    listingUrl: "https://maps.apple.com/place?auid=12369490545116377690",
    listingId: "1558549475879815731",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 23,
        NOT_IN_SYNC: ["ATTRIBUTES"],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "COUNTRY",
          "PHONE",
          "WEBSITE",
          "PHOTOS",
          "FAX",
          "CELLPHONE",
          "OPENINGHOURS",
          "CATEGORIES",
          "PAYMENT_OPTIONS",
          "LATITUDE",
          "LONGITUDE",
          "SOCIAL_PROFILES",
          "SPECIAL_OPENINGHOURS",
          "SOCIAL_POST",
          "DESCRIPTION_SHORT",
          "KEYWORDS",
          "TRANSACTION_LINKS",
          "SUBLOCALITY",
        ],
      },
    },
  },
  {
    id: 108618064,
    type: "GM",
    typeName: "GM",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618065,
    type: "HUAWEI",
    typeName: "Petal Search",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:23.000+02:00",
    lastChecked: "2025-07-28T18:44:54.000+02:00",
    listingUrl: null,
    listingId: "5843374569476603904",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-28T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 25,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "PHONE",
          "FAX",
          "WEBSITE",
          "DESCRIPTION_LONG",
          "OPENINGHOURS",
          "CATEGORIES",
          "PHOTOS",
          "LATITUDE",
          "LONGITUDE",
          "SPECIAL_OPENINGHOURS",
          "BRANDS",
          "VIDEOS",
          "EMAIL",
          "COUNTRY",
          "ADDRESS_EXTRA",
          "CELLPHONE",
          "PAYMENT_OPTIONS",
          "SOCIAL_PROFILES",
        ],
      },
    },
  },
  {
    id: 108618045,
    type: "STADTBRANCHENBUCH",
    typeName: "Opendi",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:22.000+02:00",
    lastChecked: "2025-07-23T01:53:57.000+02:00",
    listingUrl: "https://amsterdam.opendi.nl/1781620.html",
    listingId: "1781620",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-22T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 24,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "WEBSITE",
          "EMAIL",
          "DESCRIPTION_LONG",
          "OPENINGHOURS",
          "CATEGORIES",
          "PHOTOS",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "VIDEOS",
        ],
      },
    },
  },
  {
    id: 108618063,
    type: "UBER",
    typeName: "Uber",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:23.000+02:00",
    lastChecked: "2025-07-05T08:07:06.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-05T00:00:00.000+02:00",
        pointsReached: 3,
        maxPoints: 20,
        NOT_IN_SYNC: [
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PROVINCE",
          "PHONE",
          "DESCRIPTION_SHORT",
          "OPENINGHOURS",
          "CATEGORIES",
          "PHOTOS",
          "LATITUDE",
          "LONGITUDE",
        ],
        IN_SYNC: ["NAME", "WEBSITE"],
      },
    },
  },
  {
    id: 108618044,
    type: "TUPALO",
    typeName: "Tupalo",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:48.000+02:00",
    lastChecked: "2025-07-23T01:54:22.000+02:00",
    listingUrl:
      "https://www.tupalo.nl/amsterdam/factory-girl-brunch-restaurant",
    listingId: "1ji2rh6",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-22T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 22,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "ADDRESS_EXTRA",
          "PHONE",
          "WEBSITE",
          "DESCRIPTION_LONG",
          "OPENINGHOURS",
          "KEYWORDS",
          "CATEGORIES",
          "PHOTOS",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "PAYMENT_OPTIONS",
          "VIDEOS",
        ],
      },
    },
  },
  {
    id: 108618038,
    type: "HOTFROG",
    typeName: "Hotfrog",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-03-06T07:38:50.000+01:00",
    lastChecked: "2025-07-31T00:44:00.000+02:00",
    listingUrl: "https://www.hotfrog.nl/company/1472157403906048",
    listingId: "1472157403906048",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 25,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "CELLPHONE",
          "FAX",
          "WEBSITE",
          "EMAIL",
          "DESCRIPTION_LONG",
          "OPENINGHOURS",
          "KEYWORDS",
          "CATEGORIES",
          "PHOTOS",
          "ATTRIBUTION",
          "SOCIAL_PROFILES",
          "SOCIAL_POST",
          "PAYMENT_OPTIONS",
          "BRANDS",
          "SERVICES",
          "LANGUAGES",
          "SUBLOCALITY",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
        ],
      },
    },
  },
  {
    id: 108618054,
    type: "BMW",
    typeName: "BMW",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618060,
    type: "NOKIA_HERE",
    typeName: "HERE",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:23.000+02:00",
    lastChecked: "2025-07-29T20:45:05.000+02:00",
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-29T00:00:00.000+02:00",
        pointsReached: 3,
        maxPoints: 24,
        NOT_IN_SYNC: [
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "CATEGORIES",
          "PHOTOS",
          "OPENINGHOURS",
          "LATITUDE",
          "LONGITUDE",
        ],
        IN_SYNC: [
          "NAME",
          "COUNTRY",
          "FAX",
          "EMAIL",
          "WEBSITE",
          "KEYWORDS",
          "VIDEOS",
        ],
      },
    },
  },
  {
    id: 108618053,
    type: "WHERE_TO",
    typeName: "Where To?",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:30.000+02:00",
    lastChecked: "2025-07-24T06:54:05.000+02:00",
    listingUrl: "https://wheretoapp.com/search?poi=2618349398953941338",
    listingId: "2618349398953941338",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-24T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 27,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "WEBSITE",
          "EMAIL",
          "DESCRIPTION_LONG",
          "OPENINGHOURS",
          "OPENINGHOURS_NOTES",
          "KEYWORDS",
          "CATEGORIES",
          "PHOTOS",
          "SOCIAL_POST",
          "CONTENT_LISTS",
          "VIDEOS",
          "ATTRIBUTION",
          "PAYMENT_OPTIONS",
          "LANGUAGES",
          "BRANDS",
          "SERVICES",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "ADDRESS_EXTRA",
        ],
      },
    },
  },
  {
    id: 108618048,
    type: "INFOBEL",
    typeName: "Infobel",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:22.000+02:00",
    lastChecked: "2025-07-28T18:44:59.000+02:00",
    listingUrl:
      "https://www.infobel.com/nl/netherlands/factory_girl_brunch_restaurant_/amsterdam/NL102037611-0208545913/businessdetails.aspx",
    listingId: "NL102037611",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-28T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 27,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "WEBSITE",
          "EMAIL",
          "LEGAL_IDENT",
          "DESCRIPTION_LONG",
          "KEYWORDS",
          "PAYMENT_OPTIONS",
          "SERVICES",
          "BRANDS",
          "PHOTOS",
          "VIDEOS",
          "OPENINGHOURS",
          "OPENINGHOURS_NOTES",
          "CATEGORIES",
          "SOCIAL_PROFILES",
          "LATITUDE",
          "LONGITUDE",
          "ADDRESS_DISPLAY",
          "ADDRESS_EXTRA",
        ],
      },
    },
  },
  {
    id: 108618057,
    type: "NAVMII",
    typeName: "Navmii",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-02T04:22:26.000+02:00",
    lastChecked: "2025-07-28T18:45:23.000+02:00",
    listingUrl:
      "http://livepoi.navmii.com/p/view/f36f74d9-8a91-486a-8a00-2bab88220739",
    listingId: "f36f74d9-8a91-486a-8a00-2bab88220739",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-28T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 23,
        NOT_IN_SYNC: [],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ZIP",
          "CITY",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "ADDRESS_EXTRA",
          "CATEGORIES",
          "DESCRIPTION_LONG",
          "PHOTOS",
          "VIDEOS",
          "PAYMENT_OPTIONS",
          "OPENINGHOURS",
          "SOCIAL_POST",
          "WEBSITE",
          "LATITUDE",
          "LONGITUDE",
        ],
      },
    },
  },
  {
    id: 108618062,
    type: "VW",
    typeName: "VW",
    claimStatus: "NOT_CLAIMABLE",
    syncStatus: "NO_ONLINE_LISTING",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: null,
    lastChecked: null,
    listingUrl: null,
    listingId: null,
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {},
  },
  {
    id: 108618055,
    type: "I_GLOBAL",
    typeName: "iGlobal",
    claimStatus: "CLAIMED_BY_US",
    syncStatus: "NOT_IN_SYNC",
    status: "ACTIVE",
    mandatoryFields: [],
    lastSuccessfulUpdate: "2025-04-03T01:36:28.000+02:00",
    lastChecked: "2025-07-31T00:44:24.000+02:00",
    listingUrl: "https://www.iglobal.co/nederland/amsterdam/factory-girl",
    listingId: "NL-150628",
    connectStatus: "NOT_NEEDED",
    syncCheckRules: [],
    data: {
      latestVisibilityIndex: {
        date: "2025-07-30T00:00:00.000+02:00",
        pointsReached: 17,
        maxPoints: 27,
        NOT_IN_SYNC: ["WEBSITE"],
        IN_SYNC: [
          "NAME",
          "STREET",
          "STREET_NO",
          "ADDRESS_EXTRA",
          "ADDRESS_DISPLAY",
          "PROVINCE",
          "CITY",
          "ZIP",
          "COUNTRY",
          "LATITUDE",
          "LONGITUDE",
          "PHONE",
          "FAX",
          "CELLPHONE",
          "CATEGORIES",
          "DESCRIPTION_LONG",
          "EMAIL",
          "OPENINGHOURS",
          "OPENINGHOURS_NOTES",
          "SOCIAL_PROFILES",
          "SOCIAL_POST",
          "PHOTOS",
          "VIDEOS",
          "CONTENT_LISTS",
          "KEYWORDS",
          "ATTRIBUTION",
          "BRANDS",
          "SERVICES",
        ],
      },
    },
  },
];
